import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgLinkedin = function SvgLinkedin(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#007EBB",
        d: "M60.137 0h-.274C26.802 0 0 26.802 0 59.863v.274C0 93.198 26.802 120 59.863 120h.274C93.198 120 120 93.198 120 60.137v-.274C120 26.802 93.198 0 60.137 0"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#FEFFFC",
        d: "M28.618 39.89q-2.369-2.203-2.367-5.445c0-2.161.79-4.057 2.367-5.529q2.37-2.202 6.109-2.203c2.493 0 4.448.736 6.024 2.203 1.581 1.468 2.367 3.313 2.367 5.529s-.79 3.977-2.367 5.444q-2.368 2.202-6.024 2.203c-2.439 0-4.528-.736-6.11-2.203m13.172 8.416v44.985H27.575V48.306zM89.107 52.75q4.647 5.043 4.646 13.857v25.89h-13.5V68.431q-.001-4.448-2.303-6.908c-1.535-1.64-3.603-2.464-6.193-2.464s-4.659.82-6.193 2.464q-2.303 2.461-2.304 6.907v24.065H49.68V48.18h13.58v5.877q2.063-2.937 5.558-4.645 3.493-1.709 7.862-1.707c5.188 0 9.333 1.681 12.427 5.045"
    })));
};

export { SvgLinkedin as ReactComponent };
//# sourceMappingURL=Linkedin.svg.es.js.map
